<template>
    <div class="modal_mno_packet_item_info">
        <div class="header">
            <h4 class="title">
                {{ '"' + mno_packet_item.mno_base_packet.mno_name + '" ' + mno_packet_item.mno_base_packet.name }}
            </h4>
        </div>

        <div v-if="loading" style="height: 100%">
            <div class="spinner">
                <scale-loader />
            </div>
        </div>

        <div v-else class="content">
            <div class="header">
                <h4 class="title">
                    {{ 'Информация по базовому пакету оператора' }}
                </h4>
            </div>
            <div class="row">
                <div class="col-md-4">
                    <fg-input v-model="mno_packet_item.mno_base_packet.mno_name" type="text"
                        :label="translate('traffic_packet_list.mno_packet_item.mno_name')"
                        :readonly="true" />
                </div>
                <div class="col-md-4">
                    <fg-input v-model="mno_packet_item.mno_base_packet.name" type="text"
                        :label="translate('traffic_packet_list.mno_packet_item.name')"
                        :readonly="true" />
                </div>
                <div class="col-md-4">
                    <fg-input v-model="mno_packet_item.mno_base_packet.region" type="text"
                        :label="translate('traffic_packet_list.mno_packet_item.region')"
                        :readonly="true" />
                </div>
            </div>

            <div class="row">
                <div class="col-md-4">
                    <fg-input v-model="mno_packet_item.mno_base_packet.traffic_limit" type="text"
                        :label="translate('traffic_packet_list.mno_packet_item.traffic_limit')"
                        :readonly="true" />
                </div>
                <div class="col-md-4">
                    <fg-input v-model="mno_packet_item.mno_base_packet.cost" type="text"
                        :label="translate('traffic_packet_list.mno_packet_item.cost')"
                        :readonly="true" />
                </div>
                <div class="col-md-4">
                    <fg-input v-model="mno_packet_item.mno_base_packet.billing_period" type="text"
                        :label="translate('traffic_packet_list.mno_packet_item.period_type')"
                        :readonly="true" />
                </div>
            </div>

            <div class="row">
                <div class="col-md-4">
                    <fg-input v-model="mno_packet_item.mno_base_packet.type" type="text"
                        :label="translate('traffic_packet_list.mno_packet_item.type')"
                        :readonly="true" />
                </div>
                <div class="col-md-4">
                    <fg-input v-model="mno_packet_item.mno_base_packet.billing_type" type="text"
                        :label="translate('traffic_packet_list.mno_packet_item.billing_type')"
                        :readonly="true" />
                </div>
            </div>

            <div class="header">
                <h4 class="title">
                    {{ 'Информация по операторскому пакету трафика (#' + mno_packet_item.mno_packet_key + ')' }}
                </h4>
            </div>
            <div class="row">
                <div class="col-md-4">
                    <fg-input v-model="mno_packet_item.date" type="text"
                        :label="translate('traffic_packet_list.mno_packet_item.date')"
                        :readonly="true" />
                </div>
                <div class="col-md-4">
                    <fg-input v-model="mno_packet_item.period_start" type="text"
                        :label="translate('traffic_packet_list.mno_packet_item.period_start')"
                        :readonly="true" />
                </div>
                <div class="col-md-4">
                    <fg-input v-model="mno_packet_item.period_end" type="text"
                        :label="translate('traffic_packet_list.mno_packet_item.period_end')"
                        :readonly="true" />
                </div>
            </div>

            <div class="row">
                <div class="col-md-4">
                    <fg-input v-model="mno_packet_item.traffic" type="text"
                        :label="translate('traffic_packet_list.mno_packet_item.traffic')"
                        :readonly="true" />
                </div>
                <div class="col-md-4">
                    <fg-input v-model="mno_packet_item.imsi" type="text"
                        :label="translate('traffic_packet_list.mno_packet_item.imsi')"
                        :readonly="true" />
                </div>
                <div class="col-md-4">
                    <fg-input v-model="mno_packet_item.iccid" type="text"
                        :label="translate('traffic_packet_list.mno_packet_item.iccid')"
                        :readonly="true" />
                </div>
            </div>

            <div class="row">
                <div class="col-md-4">
                    <fg-input v-model="status_text" type="text"
                        :label="translate('traffic_packet_list.mno_packet_item.status')"
                        :readonly="true" />
                </div>
            </div>


            <div class="row">
                <div class="col-md-4">
                    <fg-input v-model="date_start" type="text"
                        :label="translate('traffic_packet_list.mno_packet_item.ts_create')"
                        :readonly="true" />
                </div>
                <div class="col-md-4">
                    <fg-input v-model="date_update" type="text"
                        :label="translate('traffic_packet_list.mno_packet_item.ts_update')"
                        :readonly="true" />
                </div>
                <div class="col-md-4">
                    <fg-input v-model="date_end" type="text" v-if="mno_packet_item.ts_end > 0"
                        :label="translate('traffic_packet_list.mno_packet_item.ts_end')"
                        :readonly="true" />
                </div>
            </div>
            <div class="modal_clients__footer">
              <div class="text-center">
                <span
                    v-if="false"
                    class="btn btn-success btn-fill btn-wd marginButton"
                    @click.prevent="save_change"
                >
                        {{ translate('close') }}
                    </span>

                <span
                  class="btn btn-danger btn-fill btn-wd marginButton"
                  @click.prevent="close"
                >
                  {{ translate('close_modal') }}
                </span>
              </div>
            </div>
        </div>
    </div>
</template>
<script>



export default {
    name: "MnoPacketItem",
    props: ['mno_packet_item_id'],
    data() {
        return {
            mno_packet_item: {
              mno_base_packet: {}
            },
            options: {
                day: '2-digit',
                month: '2-digit',
                year: 'numeric',
            },
            loading: true,
            tariff_active: true
        }
    },

    created() {
        this.init()
    },

    computed:{
        date_start(){
            return this.mno_packet_item.ts_create > 0 ? this.get_date(this.mno_packet_item.ts_create, this.options ) : ''
        },
        date_update(){
            return this.mno_packet_item.ts_update > 0 ? this.get_date(this.mno_packet_item.ts_update, this.options) : ''
        },
        date_end(){
            return this.mno_packet_item.ts_end > 0 ? this.get_date(this.mno_packet_item.ts_end, this.options) : ''
        },
        is_required(){
            return this.mno_packet_item.mno_base_packet.is_required ? 'Основной':'Дополнительный';
        },
        status_text() {
            return this.mno_packet_item.status > 0 ? 'Активен':'Не активен';
        },
    },

    methods: {
        close() {
            this.$emit('close')
        },
        init() {
            this.$http.v1.getMnoPacketItem(this.mno_packet_item_id, (response) => {
                this.mno_packet_item = response.data
                this.loading = false
            })
        },
    }
}
</script>
<style lang="scss" scoped>
.modal_mno_packet_item_info {
    width: 100%;
    border-radius: 3px;
    box-shadow: 0 2px 2px rgba(204, 197, 185, 0.5);
    color: #252422;
    position: relative;
    border: 1px solid #ccc;
    min-height: 85px;
    background-color: #f8f8f8;
    padding: 10px;

    .header {
        text-align: center;
        .title {
            margin-top: 15px;
        }
    }

}

.content {
    .row {
        margin: 0;
        text-align: left;
    }
}
</style>
